import { Box, Card, Typography } from "@mui/material";
import React, { FC } from "react";
import {
  boxIconContainer,
  cardStyle,
  cardStyleActive,
  iconStyle,
} from "./PetCardNew.style";
import { colorTheme, getSOCStatusDataMap } from "../../utils/SOCUtils";

import AvatarCustom from "../AvatarCustom/AvatarCustom";
import { ChipCustom } from "../../styles/styledComponents";
import { IPetItemResponse } from "../../services/pet-list/pet-list.interface";
import { SocStatusCustomIcon } from "../Icons";

interface IPetCardProps {
  isActive?: boolean;
  icon?: React.ReactElement;
  image?: string;
  title?: string;
  pet?: IPetItemResponse;
  notBold?: boolean;
  petAvatarSize?: number;
  displaySoc?: boolean;
  isWellnessPlan?: boolean;
  isDashBoardPetCardBooking?: { wellnessIconCoordinates: { x: string; y: string },
   wellnessIcon: { width: number, height: number } } | undefined;
}

const PetCardNew: FC<IPetCardProps> = ({
  isActive = false,
  icon,
  image,
  title,
  pet,
  notBold,
  petAvatarSize,
  displaySoc= false,
  isWellnessPlan,
  isDashBoardPetCardBooking,
}) => {
  return <>
    <Card sx={isActive ? cardStyleActive : cardStyle}>
      <Card className={`relative flex items-center gap-2 ps-21
        ${isActive ? "!bg-gv-yellow-light" : "bg-transparent"} h-full`}>
        <Box sx={boxIconContainer}>
          {
            icon ?
              <Box sx={iconStyle}>
                {icon}
              </Box> :
              <AvatarCustom
                sx={{ margin: "0.5rem" }}
                image={image}
                name={title || pet?.name}
                width={petAvatarSize ? petAvatarSize : 40}
                height={petAvatarSize ? petAvatarSize : 40}
                isWellnessMember={isWellnessPlan}
                isDashBoardPetCardBooking={isDashBoardPetCardBooking}
                textClass="!text-base"
              />
          }
        </Box>

        <Box>
          {title ? (
            <Typography variant="h4" sx={{ fontSize: "15px" }}>
              {title}
            </Typography>
          ) : null}

          {pet ? (
            <Typography variant="h6">
              {notBold ? (
                <span>{pet?.name}</span>
              ) : (
                <span className="grenette-pro font-semibold !text-lg">{pet?.name}</span>
              )}
            </Typography>
          ) : null}
        </Box>
        {displaySoc && pet && pet.socStatus && <ChipCustom
          icon={<SocStatusCustomIcon type={pet.socStatus as keyof typeof colorTheme} />}
          label={getSOCStatusDataMap(pet.socStatus).label}
          className="!font-semibold !text-xs !py-[0.375rem] !px-2 absolute top-[1rem] right-3"
          color={getSOCStatusDataMap(pet.socStatus).color}
          size="small"
        />}
      </Card>
    </Card>
  </>;
};

export default PetCardNew;
